import * as React from "react";

import Dialog from "@mui/material/Dialog";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";

import {
  Divider,
  Grid,
  Card,
  Typography,
  CardContent,
  ListSubheader,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import SudList from "./SudList";
import SudPictures from "./SudPictures";
import SudMoreInfoList from "./SudMoreInfoList";
import SudFeatureList from "./SudFeatureList";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog({ feature }) {
  const [open, setOpen] = React.useState(true);

  const theme = useTheme();

  const properties = feature.properties;
  const {
    site_name: siteName,
    context,
    ref_no: referenceNumber,
    borough,
    delivery_year: deliveryYear,
    weblink,
    main_delivery_org: deliveryOrg,
    notes_public: notes,
    design_standard: designStandard,
    catchment_area: catchmentArea,
    storage_volume: storageVolume,
  } = properties;

  const imageKeys = Object.keys(properties).filter((key) =>
    key.includes("img")
  );
  const imageUrls = imageKeys.map((key) => properties[key]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Card sx={{ height: "100%", overflowY: "auto" }}>
          <CardContent>
            <Grid container>
              <Grid
                item
                xs={12}
                sx={{
                  border: `1px solid ${theme.palette.primary.main}`,
                  p: 1,
                  borderRadius: 0,
                }}
              >
                <Typography component="div" variant="h5">
                  {siteName}
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  component="div"
                >
                  {context}
                </Typography>
                <Divider />
                <SudList
                  referenceNumber={referenceNumber}
                  borough={borough}
                  weblink={weblink}
                  deliveryYear={deliveryYear}
                  deliveryOrg={deliveryOrg}
                />
              </Grid>
              <ListSubheader disableSticky sx={{ background: "inherit" }}>
                Photos
              </ListSubheader>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  borderRadius: 0,
                  border: `1px solid ${theme.palette.primary.main}`,
                }}
              >
                <SudPictures imageUrls={imageUrls} />
              </Grid>
              <ListSubheader disableSticky sx={{ background: "inherit" }}>
                Properties
              </ListSubheader>
              <Grid
                item
                xs={12}
                sx={{
                  border: `1px solid ${theme.palette.primary.main}`,
                  p: 1,
                  borderRadius: 0,
                }}
              >
                <SudFeatureList properties={properties} />
              </Grid>
              <ListSubheader disableSticky sx={{ background: "inherit" }}>
                More Information
              </ListSubheader>
              <Grid
                item
                xs={12}
                sx={{
                  border: `1px solid ${theme.palette.primary.main}`,
                  p: 1,
                  borderRadius: 0,
                }}
              >
                <SudMoreInfoList
                  designStandard={designStandard}
                  notes={notes}
                  catchmentArea={catchmentArea}
                  storageVolume={storageVolume}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Dialog>
    </div>
  );
}
